import * as Utils from "../class.TransporterUtils";
import MotorParseable from "./class.MotorParseable";

export default class MathjaxBlank extends MotorParseable {
	initialize() {
		super.initialize();
		// Increment when rendering response.
		this.renderIndex = 0;
	}

	onRenderProblem($problemDiv) {
		super.onRenderProblem($problemDiv);

		// Don't focus on blanks when problem has both blanks and dropdowns.
		if (!this.model.mathjax.includes("\\dropdown")) {
			Utils.focusWhenPossible($problemDiv);
		}
	}

	getNewDriver() {
		return new Motors.Drivers.MathjaxBlankDriver();
	}

	getAnswerKey() {
		return "values";
	}

	getPreviewKey() {
		return this.model.previewKey || "newJax";
	}

	getStartSignal() {
		let values =
			this.attempt === 0 ? this.tryJSONParse(this.model.values) : this.response;
		values = _.isArray(values) ? values.map((n) => String(n)) : [];

		// convert all elements of 2D array to string
		const dropdownOptions = this.tryJSONParse(this.model.dropdownOptions).map(
			(x) => x.map((y) => String(y))
		);

		return {
			mathjax: this.model.mathjax,
			dropdownOptions,
			maxLength: this.tryJSONParse(this.model.maxLength),
			numericOnly: this.tryJSONParse(this.model.numericOnly),
			values,
		};
	}

	getDisabledSignal() {
		return {
			disabled: true,
		};
	}

	getCachedResponseSignal(data) {
		return {
			values: data.values,
		};
	}

	onRenderResponse($responseDiv) {
		this.renderIndex++;
		this.setSubmittable(this.isResponseSubmittable());

		if (this.previewKey === "newJax") {
			const preview = this.driverOutputs.newJax;
			Utils.renderJax(
				this.mainView.$el,
				$responseDiv,
				preview !== undefined ? String(preview) : ""
			);
		} else if (this.previewKey === "previewJax") {
			if (this.model.previewJax) {
				let previewStr = this.model.previewJax;
				let i = 0;
				while (previewStr.indexOf("\\blank") >= 0) {
					let str = this.driverOutputs.values[i++];
					str = Utils.sanitizeJax(str);
					str = Utils.reformatJax(str);
					previewStr = previewStr.replace(
						"\\blank",
						str ? `{${str}}` : "\\boxed{\\phantom{??}}"
					);
				}
				Utils.renderJax(this.mainView.$el, $responseDiv, previewStr);
			}
		} else if (this.previewKey === "values") {
			$responseDiv.text(
				(this.driverOutputs.values || []).filter((n) => !!n).join(", ")
			);
		}
	}

	isResponseSubmittable() {
		return (
			this.driverOutputs.values &&
			this.driverOutputs.values.every((value) => value !== "")
		);
	}

	async onRenderSubmit($submitDiv) {
		super.onRenderSubmit($submitDiv);
		if (this.model.submitJax) {
			let submitStr = this.model.submitJax;
			let i = 0;
			while (submitStr.indexOf("\\blank") >= 0) {
				let str = this.driverOutputs.values[i++];
				str = Utils.sanitizeJax(str);
				str = Utils.reformatJax(str);
				submitStr = submitStr.replace(
					"\\blank",
					str || "\\boxed{\\phantom{??}}"
				);
			}
			await Utils.renderJax(this.mainView.$el, $submitDiv, submitStr);
		}
	}
}
